import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { Login } from '../components';
import {
  RiskJudgeState,
  postRiskJudge,
  clearRiskJudgeMessages,
  clearRiskJudge,
} from '../modules/riskJudge';
import {
  postLogin,
} from '../modules/login';

import { goLoginPage, goUploadSearchPage } from '../modules/pages';
import { clearUpload } from '../modules/upload';
import { clearUploadForHighlight } from '../modules/uploadForHighlight';
import { clearUploadForRiskJudge, UploadForRiskJudgeState } from '../modules/uploadForRiskJudge';
import { clearUploadForSearch } from '../modules/uploadForSearch';
import { clearComparision } from '../modules/comparison';
import { clearComparisionForHighlight } from '../modules/comparisonHighlight';
import { clearComparisionForSearch } from '../modules/comparisonSearch';
import { clearComparisionForHighlightSave } from '../modules/comparisonHighlightSave';
import { clearSearch } from '../modules/search';
import { clearTags } from '../modules/tags';
import { clearUpdate } from '../modules/update';
import { clearDelete } from '../modules/delete';

export function mapStateToProps(state: {
  uploadForRiskJudge: UploadForRiskJudgeState,
  riskJudge: RiskJudgeState,
}) {
  const { riskJudge, messages } = state.riskJudge;
  const { files } = state.uploadForRiskJudge;
  return {
    files,
    riskJudge,
    messages,
  };
}

export function mapDispatchToProps(dispatch: ThunkDispatch<any, any, AnyAction>) {
  return {
    doRiskjudge: (id: number) => dispatch(postRiskJudge(id)),
    clearRiskJudgeMessages: () => dispatch(clearRiskJudgeMessages()),
    goLoginPage: () => {
      dispatch(clearRiskJudge());
      dispatch(goLoginPage());
    },
    goUploadPage: () => {
      dispatch(goUploadSearchPage());
      dispatch(clearUpload());
      dispatch(clearUploadForHighlight());
      dispatch(clearUploadForRiskJudge());
      dispatch(clearUploadForSearch());
      dispatch(clearRiskJudge());
      dispatch(clearComparision());
      dispatch(clearComparisionForHighlight());
      dispatch(clearComparisionForSearch());
      dispatch(clearComparisionForHighlightSave());
      dispatch(clearSearch());
      dispatch(clearTags());
      dispatch(clearUpdate());
      dispatch(clearDelete());
    },
    postLogin: (username: string, password: string) => dispatch(postLogin(username, password)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.tsx